import { Grid } from "@material-ui/core";
import AutoCompleteField from "./autocomplete";
import FromToDateField from "./from-to-date";
import UtilsFncs from "utils/UtilsFncs";
import { IsMobile } from "utils/is-mobile";

const defaultOptions = [
  { value: 15, label: "Últimos 15 dias" },
  { value: 30, label: "Últimos 30 dias" },
  { value: 60, label: "Últimos 60 dias" },
  { value: 90, label: "Últimos 90 dias" },
  { value: 120, label: "Últimos 120 dias" },
  { value: 180, label: "Últimos 180 dias" },
  { value: "Outros", label: "Outros" },
];

export default function PeriodField({
  label,
  value,
  onChange,
  disabled,
  loading,
  required,
  initialDate,
  finalDate,
  setInitialDate,
  setFinalDate,
  padding = false,
}) {
  const isMobile = IsMobile();

  const handlePeriodChange = (option) => {
    onChange(option);
    if (option && option.value !== "Outros") {
      const days = Number(option.value);
      const today = UtilsFncs.TodayDate("MM-DD-YYYY");
      const initial = UtilsFncs.GetMoment(today)
        .subtract(days - 1, "days")
        .format("MM-DD-YYYY");
      setInitialDate(initial);
      setFinalDate(today);
    } else if (option && option.value === "Outros") {
      setInitialDate("");
      setFinalDate("");
    }
  };

  return (
    <Grid
      style={{
        display: "flex",
        gap: "16px",
        paddingLeft: padding ? "8px" : "",
      }}
    >
      <Grid xs={isMobile ? 12 : value && value.value === "Outros" ? 4 : 12}>
        <AutoCompleteField
          options={defaultOptions}
          label={label}
          value={value || defaultOptions[1]}
          onChange={handlePeriodChange}
          disabled={disabled}
          loading={loading}
          required={required}
          optionLabelKey="label"
          optionIdKey="value"
        />
      </Grid>
      <Grid xs={isMobile ? 12 : 8} hidden={value?.value != "Outros"}>
        <FromToDateField
          label="Selecione o período"
          disabled={disabled}
          initialDate={initialDate}
          finalDate={finalDate}
          setInitialDate={setInitialDate}
          setFinalDate={setFinalDate}
          isMobile={isMobile}
          pattern="en"
        />
      </Grid>
    </Grid>
  );
}

export function getPeriodLabel({ period, initialDate, finalDate }) {
  if (period === "Outros") {
    const formattedInitial =
      UtilsFncs.GetMoment(initialDate).format("DD/MM/YYYY");
    const formattedFinal = UtilsFncs.GetMoment(finalDate).format("DD/MM/YYYY");
    return `entre ${formattedInitial} e ${formattedFinal}`;
  }
  return `dos últimos ${period} dias`;
}
